module.exports = __webpack_public_path__ + "/images/mockup_aportaciones_ES.0aa4044.png";